module.exports = __webpack_public_path__ + "img/model_57.671af22b.jpg";